var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4384 4C19.2651 2.33333 22.8188 -0.4 22.4203 2C21.9221 5 22.4203 10.5001 22.4203 11.0001C22.4203 11.5001 22.9185 12.5001 21.4239 11.5001C19.9293 10.5001 18.4348 9.50005 17.9366 9.00005M0.514221 3.42588C0.384967 2.40598 1.08137 0.531092 4.90537 0.531092C9.82975 0.531092 15.301 0.0336237 15.301 3.01843C15.301 6.00324 16.3953 14.9577 12.5652 14.4602C9.50112 14.0622 5.0874 14.2944 3.26356 14.4602C2.35175 14.626 0.528131 14.3607 0.528131 11.9728V3.6054C0.528131 3.54471 0.521851 3.48609 0.514221 3.42588Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0c59447d6eb2cc1e462d124dab8eb8bb.svg";
export { ForwardRef as ReactComponent };